import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const technicalIndicatorOscillatorAC: CriterionType[] = [
  {
    id: 'TECH-O-10',
    label: 'RSI (14D)',
    shortLabel: 'RSI14',
    group: AC_GROUPS.technicalIndicatorOscillator,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'TECH-O-20',
    label: 'Fast stochastic',
    shortLabel: 'FastStoch',
    group: AC_GROUPS.technicalIndicatorOscillator,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'TECH-O-30',
    label: 'Slow stochastic',
    shortLabel: 'SlowStoch',
    group: AC_GROUPS.technicalIndicatorOscillator,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'TECH-O-40',
    label: 'Directional movement indicator (DMI)',
    shortLabel: 'DMI',
    group: AC_GROUPS.technicalIndicatorOscillator,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'TECH-O-50',
    label: 'Rank correlation index (RCI)',
    shortLabel: 'RCI',
    group: AC_GROUPS.technicalIndicatorOscillator,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'TECH-O-60',
    label: 'Psychological line',
    shortLabel: 'PsychLine',
    group: AC_GROUPS.technicalIndicatorOscillator,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'TECH-O-70',
    label: 'MACD bullish',
    shortLabel: 'MACDBull',
    group: AC_GROUPS.technicalIndicatorOscillator,
    type: AC_TYPES.normal,
  },
  {
    id: 'TECH-O-80',
    label: 'MACD bearish',
    shortLabel: 'MACDBear',
    group: AC_GROUPS.technicalIndicatorOscillator,
    type: AC_TYPES.normal,
  },
];

export default technicalIndicatorOscillatorAC;
